export default "__VITE_ASSET__DPJW117N__"